<template>
  <v-textarea
    v-model="model"
    v-debounce:[debounceTime]="onDebounce"
    v-bind="$attrs"
    color="primary"
  />
</template>

<script setup lang="ts">
import { toRefs, useAttrs } from 'vue'

defineOptions({
  name: 'SfDebouncedTextarea',
  inheritAttrs: false
})

const emit = defineEmits<{ debounce: [string] }>()
const props = withDefaults(defineProps<{ debounceTime?: string | number }>(), {
  debounceTime: '500ms'
})

const [model, modifiers] = defineModel<string | null>({
  set(value): string | null {
    return value
  }
})

const attrs = useAttrs()
const { debounceTime } = toRefs(props)

const normalize = (value: string) => {
  return modifiers.noFixSpaces ? value : value.trim().replace(/\s{2,}/g, ' ')
}

const onDebounce = (value: string) => {
  if (!attrs.readonly) {
    const normalized = normalize(value)
    if (model.value !== normalized) {
      model.value = normalized
    }
    emit('debounce', normalized)
  }
}
</script>
